

let cursor = document.querySelector('#cursor');

function updateCursor(e) {
  const mouseX = e.pageX;
  const mouseY = e.pageY;

  // Déplacement de l'animation en fonction de la position de la souris
  //si la curseur dépasse la taille de la fenêtre alors on le fait disparaitre
  if (mouseX > window.innerWidth -47 || mouseY > document.body.offsetHeight) {
    cursor.style.display = "none";
  }
  else {
    cursor.style.display = "block";
  }
  cursor.style.top = `${mouseY-10}px`;
  cursor.style.left = `${mouseX+2}px`;
}

// Événement de mouvement de la souris
document.addEventListener('mousemove', (e) => {
  updateCursor(e);
});


let elements = [];
let bold = document.querySelectorAll('.card');
let navLi = document.querySelectorAll('.navLi');
let lienButton= document.querySelectorAll('.lienButton');
elements.push(...bold, ...navLi,...lienButton);

elements.forEach((item) => {
  if (document.body.offsetWidth > 850) {
    // item.addEventListener('mouseenter', () => {
    //   cursor.style.visibility = "visible";
    //   cursor.style.display = "block";
    //   animation.play();
    // })
    // item.addEventListener('mouseleave', () => {
    //   cursor.style.visibility = "hidden";
    //   animation.stop();
    // })
  }
})